import { Subject } from 'rxjs/Subject';

// tslint:disable

export class ListLib {
    public member: any[] = [];
    public config: any = {};
    public isLoading$: Subject<boolean> = new Subject();
    public onTriggerFetch$: Subject<boolean> = new Subject();

    public pagination = {
        onPaginate$: new Subject()
    };

    public console: any = {
        onQuery$: new Subject<string>()
    };

    public setMember(raw: any[]) {
        this.member = raw;
    }

    public refetch() {
        this.onTriggerFetch$.next(true);
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/list.lib.ts